import dayjs from "dayjs";
import customParseFormat from 'dayjs/plugin/customParseFormat' 

dayjs.extend(customParseFormat);

export function obterCampoAdicionalPorSiglaIgnoreCase(camposAdicionais, siglaCampoAdicional) {
    return camposAdicionais && siglaCampoAdicional ?
        camposAdicionais.find((campo) => (campo.sigla && (campo.sigla.toUpperCase() === siglaCampoAdicional.toUpperCase()))) : null;
}

export function obterCampoAdicionalPorTipoDocumento(camposAdicionais, tipoDocumento) {
    return camposAdicionais && tipoDocumento ?
        camposAdicionais.find((campo) => (campo.tipoDocumento && (campo.tipoDocumento === tipoDocumento))) : null;
}

export function obterCampoAdicionalPorNomeIgnoreCase(camposAdicionais, nomeCampoAdicional) {
    return camposAdicionais && nomeCampoAdicional ?
        camposAdicionais.find((campo) => (campo.nome && (campo.nome.toUpperCase() === nomeCampoAdicional.toUpperCase()))) : null;
}

export function dataStringToIso(dataString) {
    let data = dayjs(dataString, 'DD/MM/YYYY').add(3, 'hour')
    return data.toISOString();
  }